module.exports = __webpack_public_path__ + "img/065.e1411a25.png";